<template>
	<section class="container-virtual-tour" :id="[index]">
		<div class="container" v-if="windowWidth >= 768">
			<h2>{{ virtualTourData.config.title }}</h2>
			<div class="virtual-tour">
				<iframe :src="virtualTourData.config.virtualTourLink" width="100%" height="150" frameborder="0"
					allowfullscreen></iframe>
			</div>
		</div>
		<div class="virtual-tour-icon" v-else>
			<a :href="virtualTourData.config.virtualTourLink" target="_blank">
				<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 123.09">
					<defs></defs>
					<g>
						<g>
							<path
								d="M36.69,69.12c2.16,1.39,7.19,3.55,12.47,3.55,9.78,0,12.82-6.23,12.73-10.91-.09-7.88-7.19-11.26-14.55-11.26h-4.24v-5.72h4.24c5.54,0,12.56-2.86,12.56-9.53,0-4.5-2.86-8.49-9.87-8.49-4.5,0-8.83,1.99-11.26,3.72l-1.99-5.54c2.94-2.16,8.66-4.33,14.72-4.33,11.08,0,16.11,6.58,16.11,13.42,0,5.8-3.46,10.74-10.39,13.25v.17c6.93,1.39,12.56,6.58,12.56,14.46,0,9.01-7.01,16.89-20.52,16.89-6.32,0-11.86-1.99-14.63-3.81l2.08-5.89Z" />
							<path
								d="M111.42,26.95c-1.56-.09-3.55,0-5.72,.35-11.95,1.99-18.27,10.74-19.57,20h.26c2.68-3.55,7.36-6.49,13.6-6.49,9.96,0,16.97,7.19,16.97,18.18,0,10.3-7.01,19.83-18.7,19.83s-19.92-9.35-19.92-23.99c0-11.08,3.98-19.83,9.53-25.37,4.68-4.59,10.91-7.45,18.01-8.31,2.25-.35,4.16-.43,5.54-.43v6.23Zm-2.16,32.47c0-8.05-4.59-12.9-11.6-12.9-4.59,0-8.83,2.86-10.91,6.93-.52,.87-.87,1.99-.87,3.38,.17,9.27,4.42,16.11,12.38,16.11,6.58,0,11-5.46,11-13.51Z" />
							<path
								d="M161.13,49.12c0,19.14-7.1,29.7-19.57,29.7-11,0-18.44-10.3-18.62-28.92,0-18.88,8.14-29.27,19.57-29.27s18.62,10.56,18.62,28.49Zm-30.57,.87c0,14.63,4.5,22.95,11.43,22.95,7.79,0,11.52-9.09,11.52-23.47s-3.55-22.95-11.43-22.95c-6.67,0-11.52,8.14-11.52,23.47Z" />
						</g>
						<path
							d="M200,72.93c0-9.84-7.23-18.93-19.46-26.29-1.44-.87-2.89,1.06-1.67,2.21,5.11,4.82,7.96,10.19,7.96,15.85,0,15.08-20.25,28.1-49.54,34.19,0,0-13.88,2.46-30.21,2.3v15.01c6.36,0,13.2-.44,18.76-.91,10.05-.86,20.01-2.59,29.67-5.45,26.82-7.95,44.48-21.51,44.48-36.89Z" />
						<path
							d="M64.91,89.19v10.13c-30.48-5.88-51.75-19.17-51.75-34.63,0-5.66,2.85-11.03,7.96-15.85,1.21-1.14-.26-3.06-1.69-2.2C7.22,54.01,0,63.1,0,72.93c0,19.02,26.99,35.24,64.91,41.54v8.61l12.39-6.95,17.82-10-7.04-3.95-23.17-13Z" />
					</g>
					<circle class="cls-1" cx="164.68" cy="10" r="7.8" transform="translate(.82 26.35) rotate(-9.17)" />
				</svg>
			</a>
		</div>
	</section>
</template>
    
<script>
export default {
	props: {
		virtualTourData: {
			type: Object,
		},
		index: {
			type: Number
		}
	},
	data() {
		return {
			windowWidth: window.innerHeight
		}
	},
	mounted() {
		this.windowWidth = window.innerWidth;

		window.onresize = () => {
			this.windowWidth = window.innerWidth
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/virtualTourComponent.scss";
</style>
